// extracted by mini-css-extract-plugin
export default {"title":"Home_title__AjI9b","stock_row":"Home_stock_row__pWMgC","price":"Home_price__oInlk"};